module.exports = __webpack_public_path__ + "img/j.fffb0e32.jpg";